export const billing = {
aiUsageAudit: {
title: "Auditoría de IA y automatización del espacio de trabajo",
loading: "Cargando registro de auditoría...",
empty: "Aún no hay eventos de auditoría.",
intro: "Registro de auditoría de los conectores de IA y automatización de este espacio de trabajo. Muestra los últimos 200 eventos con capacidad, traza, uso y metadatos de créditos cuando están disponibles.",
refresh: "Actualizar",
refreshing: "Actualizando...",
noAccount: "No se encontró ninguna cuenta de espacio de trabajo para este perfil.",
loadFailed: "No se pudieron cargar los eventos de auditoría.",
service: "Servicio:",
status: "Estado:",
filters: {
all: "Todos",
success: "Correcto",
error: "Error",
ai: "IA",
automation: "Automatización",
},
totalCredits: "Créditos de IA totales (filtrados):",
totalShown: "Total mostrado:",
creditUnitsLogged: "Unidades de crédito registradas (IA + automatización, eventos mostrados):",
noEventsFiltered: "No se encontraron eventos para los filtros seleccionados.",
memberTitle: "Uso de IA",
memberSubtitle: "Todos los miembros de su espacio de trabajo comparten los créditos de IA.",
memberBody: "El propietario revisa el uso de IA de este espacio de trabajo. El saldo de créditos compartido está en Facturación y uso.",
},
usage: {
addons: {
  title: "Complementos",
  subtitle: "Funciones extra para su plan, de pago por activo.",
  loadFailed: "No se pudieron cargar los complementos. Inténtelo más tarde.",
  perAssetMonth: "{{price}} por activo al mes",
  included: "Incluido en su plan",
  statusTrialing: "Activado: prueba gratuita hasta el {{date}}",
  statusActive_one: "Activado para {{count}} activo: {{total}} al mes",
  statusActive_many: "Activado para {{count}} activos: {{total}} al mes",
  statusActive_other: "Activado para {{count}} activos: {{total}} al mes",
  statusActiveNoPrice_one: "Activado para {{count}} activo",
  statusActiveNoPrice_many: "Activado para {{count}} activos",
  statusActiveNoPrice_other: "Activado para {{count}} activos",
  statusOff: "Desactivado",
  notOnPlan: "No está en su plan. Cambie de plan para añadirlo (en Planes verá cuáles lo permiten).",
  notAvailableInApp: "No se puede comprar en la app",
  adminsOnly: "Los administradores del espacio de trabajo añaden o desactivan complementos.",
  coverTitle: "Qué cubre",
  coverWhole: "Todo el espacio de trabajo",
  coverSites: "Sitios elegidos",
  coverHint: "Un sitio elegido cubre también los sitios que contiene.",
  noSites: "Aún no hay sitios: cubre todo el espacio de trabajo.",
  liveTotal_one: "{{count}} activo × {{price}} = {{total}} al mes",
  liveTotal_many: "{{count}} activos × {{price}} = {{total}} al mes",
  liveTotal_other: "{{count}} activos × {{price}} = {{total}} al mes",
  trialNote: "Gratis durante {{days}} días y después se factura con su plan. Puede desactivarlo cuando quiera.",
  proRata: "Los cambios se aplican hoy y se cobran o abonan de forma proporcional en su próxima factura.",
  startTrial: "Empezar prueba gratuita de {{days}} días",
  startPaid: "Añadir a mi plan",
  save: "Guardar cobertura",
  end: "Desactivar",
  keep: "Mantener",
  endConfirmTitle: "¿Desactivar {{name}}?",
  endConfirmBody: "Termina hoy y el tiempo pagado no usado se abona en su próxima factura. Sus datos ESG se conservan y vuelven si lo activa de nuevo.",
  chooseSite: "Elija al menos un sitio o todo el espacio de trabajo.",
  failed: "No se pudo actualizar el complemento. Inténtelo de nuevo.",
},
  assistantGate: {
    debitFailedMember: "El asistente no pudo usar créditos para esta solicitud. Inténtalo de nuevo en un momento.",
    debitFailedAdmin: "El asistente no pudo usar créditos para esta solicitud. Inténtalo de nuevo o revisa Facturación y uso si sigue pasando.",
    debitFailedTitle: "No se pudieron usar los créditos",
    disabledAdmin: "La IA no está incluida en el plan de este espacio de trabajo. Abre Facturación y uso para ver los planes que la incluyen.",
    disabledMemberUnnamed: "La IA no está incluida en el plan de este espacio de trabajo. Habla con el propietario del espacio de trabajo sobre el plan.",
    disabledMember: "La IA no está incluida en el plan de este espacio de trabajo. Habla con {{owner}} sobre el plan.",
    disabledTitle: "El asistente de IA está desactivado",
  },
  assetGate: {
    seePlans: "Ver planes",
    subscriptionRequired: "Tu espacio de trabajo ha usado los activos gratuitos de su plan. Inicia una suscripción para añadir más activos.",
    askOwner: "Pide al propietario del espacio de trabajo que añada un plan para poder añadir más activos.",
    askOwnerNamed: "Pide al propietario de {{workspace}} que añada un plan para poder añadir más activos.",
    title: "Se necesita una suscripción",
  },
  checkout: {
    unavailable: "La compra no está disponible en este momento. Inténtalo más tarde.",
    needsEmail: "Añade un correo electrónico a tu perfil antes de iniciar el pago.",
    contactSales: "Este plan lo vende nuestro equipo. Contacta con AssetWRX para empezar.",
    notConfigured: "Este plan aún no se puede comprar. Contacta con soporte.",
    generic: "No pudimos iniciar el pago. Inténtalo de nuevo en un momento o contacta con soporte si sigue pasando.",
  },
  store: {
    planGone: "Ese plan ya no se ofrece. Cierra y vuelve a abrir esta pantalla.",
    unavailable: "Las compras en la tienda no están disponibles en esta versión de la app.",
    purchaseFailed: "La compra no se completó. Inténtalo de nuevo.",
    ownerOnly: "Solo el propietario del espacio de trabajo puede gestionar su suscripción en la tienda.",
  },
  workAi: {
    hostFallback: "el espacio de trabajo",
    settingTitle: "IA para las personas con las que trabajas",
    settingSubtitle: "Los contratistas y solicitantes pueden usar IA en tus trabajos, inspecciones y activos, pagada con tus créditos.",
    settingLabel: "Créditos al mes por persona",
    settingHelper: "Déjalo en blanco para la asignación estándar. 0 la desactiva.",
    settingPlaceholder: "Estándar",
    settingInvalid: "Introduce un número entero o déjalo en blanco.",
    settingSave: "Guardar",
    settingSaved: "Guardado",
    settingFailed: "No se pudo guardar la asignación",
    usedTitle: "La IA de {{host}} de este mes se ha agotado",
    offTitle: "{{host}} no incluye IA en su trabajo",
    useOwnBody: "Puedes usar tus propios créditos de IA en su lugar.",
    notNow: "Ahora no",
    useOwn: "Usar mis créditos",
    refused: "La IA de {{host}} de este mes se ha agotado.",
  },
  aiGate: {
    freePeriodEnded: "La IA está en pausa porque el período gratuito terminó y este espacio de trabajo es de solo lectura.",
    pastDue: "La IA está en pausa por un fallo de pago. Actualiza la facturación para volver a activarla.",
    canceled: "La IA está desactivada porque se canceló la suscripción de este espacio de trabajo.",
    notEnoughCredits_other: "Esto necesita {{count}} créditos de IA y tu espacio de trabajo no tiene suficientes.",
    notEnoughCredits_many: "Esto necesita {{count}} créditos de IA y tu espacio de trabajo no tiene suficientes.",
    notEnoughCredits_one: "Esto necesita {{count}} crédito de IA y tu espacio de trabajo no tiene suficientes.",
    readOnly: "La IA está en pausa porque este espacio de trabajo es de solo lectura.",
    notInPlan: "La IA no está incluida en el plan de este espacio de trabajo.",
    checkFailed: "No pudimos comprobar tus créditos de IA. Inténtalo de nuevo.",
  },
  creditCode: {
    refund: "Reembolso",
    adjustment: "Ajuste",
    included: "Créditos incluidos",
    purchase: "Compra",
    topUp: "Recarga",
    aiCredits: "Créditos de IA",
    aiUsage: "Uso de IA",
  },
  packCredits_other: "{{count}} créditos",
  packCredits_many: "{{count}} créditos",
  packCredits_one: "{{count}} crédito",
  planLoadFailed: "No se pudo cargar tu plan.",
  ownerManagesUnnamed: "El propietario del espacio de trabajo gestiona el plan y los créditos.",
  ownerManages: "{{owner}} gestiona el plan y los créditos de este espacio de trabajo.",
  confirmationAwaitingBody: "Termina de pagar en la ventana de pago y vuelve aquí. Toca Actualizar si tu plan y tus créditos no se han actualizado.",
  confirmationAwaitingTitle: "Esperando tu pago",
  paymentStatusInactiveDetailMember: "No hay ninguna suscripción activa. El propietario del espacio de trabajo puede iniciar una.",
  paymentStatusPausedDetailMember: "La suscripción está en pausa. El propietario del espacio de trabajo puede reanudarla.",
  paymentStatusPastDueDetailMember: "Hay un pago vencido. El propietario del espacio de trabajo puede resolverlo en Facturación y uso.",
  statusFreePeriodEndedMember: "El período gratuito terminó y el espacio de trabajo es de solo lectura. El propietario puede elegir un plan; no se ha borrado nada.",
  statusFreeLimitReachedMember: "Se alcanzó el límite gratuito. El propietario del espacio de trabajo puede elegir un plan para añadir más activos.",
  statusFreeUntilMember: "Gratis hasta el {{date}}. El propietario del espacio de trabajo elige el plan.",
  statusFreeFirstAsset_other: "Tu plan incluye {{count}} activos gratis. La facturación empieza cuando añades más.",
  statusFreeFirstAsset_many: "Tu plan incluye {{count}} activos gratis. La facturación empieza cuando añades más.",
  statusFreeFirstAsset_one: "Tu plan incluye {{count}} activo gratis. La facturación empieza cuando añades el siguiente.",
  creditsNeeded_other: "Esto necesita {{count}} créditos y tienes {{balance}}.",
  creditsNeeded_many: "Esto necesita {{count}} créditos y tienes {{balance}}.",
  creditsNeeded_one: "Esto necesita {{count}} crédito y tienes {{balance}}.",
  continueWithoutAi: "Continuar sin IA",
  outOfCreditsOk: "Aceptar",
  outOfCreditsNeutral: "Tu espacio de trabajo se ha quedado sin créditos de IA. Puedes seguir trabajando sin IA.",
  outOfCreditsMemberBodyUnnamed: "Puedes seguir trabajando sin IA. Pide al propietario del espacio de trabajo que añada créditos.",
  outOfCreditsMemberBody: "Puedes seguir trabajando sin IA. Pide a {{owner}} que añada créditos.",
  outOfCreditsAdminBodyNoBuy: "Puedes seguir trabajando sin IA.",
  outOfCreditsAdminBody: "Puedes seguir trabajando sin IA o comprar un paquete de créditos.",
title: "Facturación y uso",
intro: "Revisa el estado de la suscripción, los créditos y las próximas acciones de facturación.",
summaryIntro: "Tu plan, créditos y facturación.",
outOfCreditsTitle: "Se acabaron los créditos de IA",
outOfCreditsBody: "Las acciones de IA necesitan créditos. Compra un paquete de créditos para continuar, o espera a tus créditos mensuales incluidos.",
outOfCreditsNotNow: "Ahora no",
trialCapTitle: "Por encima de tu límite de prueba",
creditPackPickerTitle: "Elige un paquete de créditos",
creditPackPickerSubtitle: "Los créditos no caducan nunca.",
buyCreditsCta: "Comprar",
cancel: "Cancelar",
kpiSectionTitle: "Resumen de uso",
kpiSectionHint: "Lo que se le factura y los créditos de IA que tiene.",
kpiAssetsTitle: "Activos facturables",
kpiAssetsBody: "Activos en uso facturados en este ciclo.",
kpiMonthlyPlanTitle: "Créditos del plan",
kpiMonthlyPlanBody: "Créditos incluidos cada mes.",
kpiMonthlyPlanBodyUnlimited: "Los créditos mensuales son ilimitados.",
kpiPurchasedTitle: "Créditos comprados",
kpiPurchasedBody: "Créditos de recarga que aún quedan disponibles.",
kpiRemainingTitle: "Créditos restantes",
kpiRemainingBody: "Créditos incluidos + comprados que quedan.",
kpiRemainingBodyUnlimited: "Los créditos son ilimitados para este espacio de trabajo.",
loading: "Cargando facturación...",
refresh: "Actualizar",
refreshing: "Actualizando...",
noAccount: "No se encontró ninguna cuenta de espacio de trabajo para este perfil.",
loadFailed: "No se pudieron cargar los datos de facturación.",
billingDataMissing: "No se pudieron mostrar los datos de facturación. Intenta actualizar.",
errorTitle: "Los datos de facturación no están disponibles",
emptyTitle: "La facturación necesita un espacio de trabajo",
emptyBody: "La facturación pertenece a un espacio de trabajo. Cambia a un espacio de trabajo para ver su plan, sus créditos y la moneda de su factura.",
planTitle: "Suscripción",
unlimited: "Ilimitado",
subscriptionSummaryTitle: "Resumen de la suscripción",
subscriptionSummarySubtitle: "Estado según el proveedor y calendario de renovación de este espacio de trabajo.",
managedOnWeb: "Los cambios de plan y créditos no están disponibles en esta aplicación.",
statusFreeUntil: "Gratis hasta el {{date}}. Elige un plan para que tu espacio de trabajo siga funcionando después.",
internalEditionName: "Developer (edición interna de pruebas)",
statusInternalEdition: "Edición interna de pruebas: todas las funciones están activas y no se factura nada. Solo se configura en Admin.",
statusGranted: "Tu plan se ofrece sin coste y sin fecha de fin.",
statusGrantedUntil: "Tu plan se ofrece sin coste hasta el {{date}}. Elige un plan antes para que tu espacio de trabajo siga funcionando.",
statusFreeFirstAsset: "Aún no hay cargos. La facturación empieza cuando añades más activos de los que tu plan incluye gratis.",
statusFreeLimitReached: "Has alcanzado tu límite gratuito. Elige un plan para añadir más activos.",
statusFreePeriodEnded: "Tu periodo gratuito ha terminado y tu espacio de trabajo es de solo lectura. Elige un plan para seguir trabajando; no se ha eliminado nada.",
statusActive: "Tu suscripción está activa.",
statusActiveRenews: "Tu suscripción está activa y se renueva el {{date}}.",
statusActiveEnds: "Tu suscripción está cancelada y termina el {{date}}. Conservas tu plan hasta entonces.",
statusBilledByStore: "Tu suscripción se factura a través de la tienda de aplicaciones. Gestiónala allí.",
changePlanHint: "Cambia a otro plan; el cambio se confirma antes de cualquier cobro.",
cancelSubscription: "Cancelar suscripción",
cancelSubscriptionHint: "Tu plan se mantiene hasta el final del periodo pagado; no se cobra nada más.",
resumeSubscription: "Reanudar suscripción",
resumeSubscriptionHint: "Conserva tu plan; se renueva como antes.",
cancelSubscriptionConfirmTitle: "¿Cancelar tu suscripción?",
cancelSubscriptionConfirmBody: "Conservas {{plan}} hasta el {{date}}; no se cobra nada más. Puedes reanudarla en cualquier momento antes de esa fecha.",
cancelSubscriptionConfirmBodyNoDate: "Conservas {{plan}} hasta el final del periodo actual; no se cobra nada más. Puedes reanudarla en cualquier momento antes de esa fecha.",
cancelSubscriptionKeep: "Mantener mi plan",
cancelSubscriptionConfirm: "Cancelar suscripción",
cancelSubscriptionError: "No se pudo cambiar tu suscripción.",
planReference: "Facturación {{plan}}",
paymentStatusLabel: "Estado del pago",
paymentStatusFreeDetail: "Aún no hay cargos. La facturación empieza cuando añades más activos de los que tu plan incluye gratis.",
paymentStatusGrantedDetail: "Se ofrece sin coste. No se factura nada.",
paymentStatusSubscriptionRequiredDetail: "Se alcanzó el límite gratuito. Inicia una suscripción para seguir añadiendo activos en uso.",
paymentStatusStripeDetail: "La facturación está activa para este espacio de trabajo.",
paymentStatusPastDueDetail: "El pago está atrasado. Resuélvelo en el portal de facturación para evitar interrupciones del servicio.",
paymentStatusPausedDetail: "La suscripción está en pausa. Reanuda la facturación antes de añadir más activos en uso.",
paymentStatusInactiveDetail: "No hay cobro activo. Inicia o restaura una suscripción para continuar con la facturación.",
paymentStatusInternalDetail: "La facturación de este espacio de trabajo aún no está configurada del todo, así que este es el último estado que tenemos.",
renewalDateLabel: "Fecha de renovación",
renewalKnownDetail: "Basado en el último periodo de suscripción sincronizado.",
renewalUnknownDetail: "El calendario de renovación aún no está disponible para este espacio de trabajo.",
lastTrueUpLabel: "Último recuento de activos",
trueUpKnownDetail: "Cuándo se contaron por última vez tus activos en uso para la facturación.",
trueUpUnknownDetail: "Tus activos aún no se han contado para la facturación.",
presentmentCurrencyLabel: "Moneda de la factura",
presentmentCurrencyBadge: "Facturación en {{currency}}",
currencyUnknown: "Desconocida",
currencyPresentmentNote: "Los precios se fijan en {{currency}}. Tu factura puede mostrar tu moneda local.",
currencyCatalogOnlyNote: "Los precios y las facturas están en {{currency}}.",
editionTitle: "Tu plan",
editionSubtitle: "Tu plan determina qué funciones están disponibles. Los activos y los créditos de IA se facturan por separado.",
monthlyAmountTitle: "Importe mensual estimado",
monthlyAmountSubtitle: "Su factura muestra el total definitivo.",
amountFinal: "Importe final",
amountEstimated: "Importe estimado",
amountUnavailable: "Importe no disponible",
amountFinalExplanation: "De la última factura liquidada.",
amountEstimatedPresentmentExplanation: "Una estimación. Su factura muestra el importe definitivo, que puede estar en su moneda local.",
amountEstimatedCatalogExplanation: "Una estimación en {{currency}}. Su factura muestra el importe definitivo.",
amountUnavailableExplanation: "Todavía no hay disponible un importe fiable de cara al cliente.",
creditsAndAssetsTitle: "Créditos y activos facturables",
creditsAndAssetsSubtitle: "Saldos operativos de uso y límites.",
billableAssetsMetric: "Activos facturables en uso",
includedMonthlyMetric: "Créditos mensuales incluidos",
purchasedCreditsMetric: "Créditos comprados",
totalRemainingCreditsMetric: "Total de créditos restantes",
pricingExplanationTitle: "Detalles de precios",
pricingExplanationSubtitle: "Bandas de facturación actuales del catálogo.",
pricingSummaryKnown: "Precios escalonados para {{assetCount}} activos facturables en uso, referenciados en {{currency}}.",
pricingSummaryUnknown: "Todavía no hay bandas de precios estructuradas disponibles en el catálogo de facturación, por lo que la aplicación no puede ofrecer una explicación de precios línea por línea de forma fiable.",
pricingBandOpenEnded: "{{min}}+ activos",
pricingBandRange: "de {{min}} a {{max}} activos",
pricingBandLabel: "{{label}}",
pricingBandUnknown: "Tarifa no disponible",
pricingBandEmpty: "Todavía no hay bandas de precios configuradas para este modelo de facturación.",
catalogReferenceNote: "Moneda de referencia del catálogo: {{currency}}.",
startSubscription: "Iniciar suscripción",
startSubscriptionHint: "Inicia una suscripción para añadir más activos de los que tu plan incluye gratis.",
startSubscriptionAdminOnly: "Solo el propietario del espacio de trabajo puede iniciar la suscripción.",
startSubscriptionStripeOff: "La compra no está disponible en este momento.",
startSubscriptionUnavailable: "Este espacio de trabajo no puede iniciar una nueva suscripción desde el estado de facturación actual.",
manageSubscriptionHint: "Abre el portal de facturación para gestionar tu suscripción o método de pago.",
manageBillingAdminOnly: "Solo el propietario del espacio de trabajo puede gestionar la facturación.",
manageBillingUnavailable: "El acceso al portal de facturación todavía no está disponible para este espacio de trabajo.",
buyMoreCredits: "Comprar créditos",
buyCreditsHint: "Compra un paquete de créditos. Pago único y seguro.",
buyCreditsAdminOnly: "Solo el propietario del espacio de trabajo puede comprar créditos.",
buyCreditsStripeOff: "La compra no está disponible en este momento.",
buyCreditsUnavailable: "Todavía no hay ningún precio de paquete de créditos configurado.",
buyCreditsPriceHint: "Precio de catálogo de referencia: {{price}}.",
priceUnavailable: "Precio no disponible",
activityTitle: "Actividad reciente de créditos",
activitySubtitle: "Últimos movimientos de créditos (vista previa).",
subscriptionDetailsTitle: "Detalles de la suscripción",
subscriptionDetailsSubtitle: "Calendario operativo y detalles de sincronización.",
currencyDetailsTitle: "Detalles de moneda",
currencyDetailsSubtitle: "Comportamiento de la moneda de presentación y de catálogo.",
showDetails: "Mostrar detalles",
hideDetails: "Ocultar detalles",
ledgerEmpty: "Aún no hay actividad de créditos.",
linkAudit: "Abrir auditoría de IA y automatización",
manageStripeBilling: "Gestionar suscripción",
stripeCheckoutError: "No se pudo abrir el pago. Inténtalo de nuevo.",
stripePortalError: "No se pudo abrir la gestión de la facturación. Inténtalo de nuevo.",
stripeConfigOff: "El pago con Stripe está desactivado. En el `.env` de la raíz del proyecto, define EXPO_PUBLIC_STRIPE_BILLING_ENABLED=true y añade EXPO_PUBLIC_STRIPE_PRICE_ID_ASSET_SUBSCRIPTION y/o EXPO_PUBLIC_STRIPE_PRICE_ID_CREDIT_PACK_100 (cada uno debe ser un ID price_... de Stripe). Reinicia Expo con `npx expo start --clear`.",
stripeConfigNoPrices: "Stripe está activado pero no se encontró ningún ID de precio válido. Usa IDs de precio de Stripe que empiecen por `price_` (no `prod_`). Define EXPO_PUBLIC_STRIPE_PRICE_ID_ASSET_SUBSCRIPTION y/o EXPO_PUBLIC_STRIPE_PRICE_ID_CREDIT_PACK_100 en `.env` y reinicia Expo.",
confirmationConfirmedTitle: "Compra completada",
confirmationCancelledTitle: "Pago cancelado",
confirmationPendingTitle: "Terminando tu compra",
confirmationConfirmedBody: "Listo. Tu plan y tus créditos de abajo están al día.",
confirmationCancelledBody: "No se aplicó ningún cambio de facturación. Tu plan y tus créditos actuales no han cambiado.",
confirmationPendingBody: "Pago recibido. Tu plan y tus créditos se actualizarán en unos segundos. Toca Actualizar si no lo han hecho.",
trialCapBody_one: "Tu prueba permite {{max}}. Tienes {{billable}} activos en uso, así que {{count}} activo empezará a facturarse cuando tu prueba pase a un plan de pago.",
trialCapBody_other: "Tu prueba permite {{max}}. Tienes {{billable}} activos en uso, así que {{count}} activos empezarán a facturarse cuando tu prueba pase a un plan de pago.",
trialCapBodyDated_one: "Tu prueba permite {{max}}. Tienes {{billable}} activos en uso, así que {{count}} activo empezará a facturarse cuando tu prueba termine el {{trialEnd}}.",
trialCapBodyDated_other: "Tu prueba permite {{max}}. Tienes {{billable}} activos en uso, así que {{count}} activos empezarán a facturarse cuando tu prueba termine el {{trialEnd}}.",
forecastTitle: "Uso y previsión de créditos de IA",
forecastSubtitle: "Cómo se usaron sus créditos en los últimos 30 días y cuánto durarán.",
consumedLast30Days: "Consumido en 30 días",
averageDailyUse: "Media por día",
estimatedRunway: "Los créditos duran unos",
runwayNotLimited: "Sin límite",
runwayDays_one: "{{count}} día",
runwayDays_other: "{{count}} días",
ledgerReconciled: "El saldo está al día",
ledgerPartial: "El saldo se está actualizando",
contactAdminTitle: "La facturación la gestiona el propietario del espacio de trabajo",
contactAdminTitleNamed: "El plan y los créditos los gestiona el propietario de {{workspace}}",
contactAdminSubtitle: "Aquí puedes ver el uso. Solo el propietario puede cambiar el plan o comprar créditos.",
viewWorkspaceAdmins: "Ver administradores del espacio de trabajo",
detailsTitle: "Datos de facturación",
detailsSubtitle: "Suscripción, precios y moneda.",
chargingPolicyTitle: "Cómo se cobran los créditos de IA",
chargingPolicySubtitle: "Qué pagas, qué no pagas y qué pasa si algo falla.",
chargingSuccess: "Se te cobra una sola vez por la IA que funciona, después de recibir el resultado.",
chargingFailure: "Un resultado de IA fallido no se cobra, y el trabajo manual sigue disponible.",
chargingRetry: "Si falla el registro del cargo, lo reintentamos una vez y nunca cobramos dos veces.",
packForecastNoPattern: "El impacto previsto aparece cuando se registra uso.",
packForecastDays_one: "Aproximadamente {{count}} día adicional al ritmo actual",
packForecastDays_other: "Aproximadamente {{count}} días adicionales al ritmo actual",
trialCapBody_many: "Tu prueba permite {{max}}. Tienes {{billable}} activos en uso, así que {{count}} activos empezarán a facturarse cuando tu prueba pase a un plan de pago.",
trialCapBodyDated_many: "Tu prueba permite {{max}}. Tienes {{billable}} activos en uso, así que {{count}} activos empezarán a facturarse cuando tu prueba termine el {{trialEnd}}.",
runwayDays_many: "{{count}} días",
packForecastDays_many: "Aproximadamente {{count}} días adicionales al ritmo actual",
},
};
